(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name summary.controller:SummaryEmailModalCtrl
   *
   * @description
   *
   */
  angular
    .module('summary')
    .controller('SummaryEmailModalCtrl', SummaryEmailModalCtrl);

  SummaryEmailModalCtrl.$inject = ['$uibModalInstance', 'DataService', '$log'];

  function SummaryEmailModalCtrl($uibModalInstance, dataService, $log) {
    var vm = this;
    vm.ctrlName = 'SummaryEmailModalCtrl';
    vm.contactInfo = {
      name: dataService.getQuestionByFlag('name').answer
    };
    vm.isSubmissionInProgress = false;
    vm.ok = ok;
    vm.cancel = cancel;
    vm.data = dataService.data;
    vm.emailPattern = dataService.emailPattern;
    vm.isSubmitDisabled = isSubmitDisabled;

    activate();

    function activate() {
      vm.data.quoteSummaryEmailResponse = undefined;
    }

    function ok() {
      $log.debug('Send email called!');
      vm.isSubmissionInProgress = true;
      dataService.sendQuoteSummaryEmail(vm.contactInfo);
    }

    function cancel() {
      $uibModalInstance.dismiss('Cancel called.');
    }

    function isSubmitDisabled() {
      return vm.isSubmissionInProgress ||
        vm.oqsContactEmail.$invalid;
    }
  }
}());
